export class DailyTripHistoryFilter {
    tripId: number;
    billOfLading: string;
    containerNumber: string;
    tripDateFrom: string;
    tripDateTo: string;
    
    userId: number;
    vehicleId: number

    constructor(){
        this.tripDateFrom = null;
        this.tripDateTo = null;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/trips/dailyTripHistoryFilter.ts